import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge must know the custom tokens of `src/index.css`: otherwise `text-body-md` looks like a text
 * colour and `cn("text-body-md", "text-white")` drops the size. Add new font-size and radius tokens here too.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "body-micro",
        "body-sm",
        "body-desc",
        "body-md",
        "body-lg",
        "title-xs",
        "title-sm",
        "title-md",
        "title-lg",
        "heading-xs",
        "heading-sm",
        "heading-md",
        "heading-lg",
      ],
      radius: ["lg2", "xl2", "2xl2", "card"],
    },
  },
});

/** Joins class names and resolves Tailwind conflicts (the last one wins). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
